/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        // Display width in real time
        $( 'body' ).prepend( "<div style='z-index: 99999; display: none; font-size: 14px; position: fixed; color: #fff !important; background: rgba(0,0,0,0.85) !important; bottom: 0; padding: 4px 8px;' id='dimensions'></div>" );
        $( '#dimensions' ).html(window.innerWidth);
        $( window ).resize(function() { $( '#dimensions' ).html( window.innerWidth ); });
        //if ( document.location.href.indexOf( 'localhost' ) !== -1 )
          $( '#dimensions' ).show();
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        /* Displays / hides mobile menu */
        $( '.header__menu_icon' ).toggle( function() {
          $( '.wrap' ).removeClass( 'mobile_menu_opening mobile_menu_closing' );
          $( '.wrap' ).addClass( 'mobile_menu_opening' ); 
          $( '.wrap' ).css( 'overflow', 'visible' ); 
        }, function() {
          $( '.wrap' ).removeClass( 'mobile_menu_opening mobile_menu_closing' );
          $( '.wrap' ).addClass( 'mobile_menu_closing' );           
          setTimeout(function() {
            $( '.wrap' ).css( 'overflow', 'hidden' ); 
          }, 250);
        });
        
        /* Displays / hides sub menus in mobile menu */
        $( '#menu-menu-mobile li.menu-item-has-children' ).toggle( function() {
          $(this).find( 'ul.sub-menu' ).fadeIn(0);
          $(this).addClass('menu-item-has-children-open');
        }, function() {
          $(this).find( 'ul.sub-menu' ).fadeOut(0);
          $(this).removeClass('menu-item-has-children-open');
        });

        /* Sous menus CARTES & RESTAURANTS */
        $( '.restaurants_li, .menu_nos_restaurants' ).hover(
          function() {
            $( '.menu_la_carte' ).fadeOut(0);
            $( '.menu_nos_restaurants' ).fadeIn(0);            
          }, function() {
            $( '.menu_la_carte' ).fadeIn(0);
            $( '.menu_nos_restaurants' ).fadeOut(0);           
          }
        );
        $( '.sub-menu' ).click(function(event) {
          event.stopPropagation();
        });

        /* Pizzas filtering tabs */
        $( '.pizza_filtering__item' ).click(function() {
          var this_element = $(this);
          var all_pizzas = $( '.pizza' );
          var hidden_pizzas = $( '.hidden_pizzas' ); 
          var all_hidden_pizzas = $( '.hidden_pizzas .pizza' ); 
          var pizzas_container = $( '.pizzas_wrap' ); 
          var all_filtering_items = $( '.pizza_filtering__item' );
          var class_current = 'pizza_filtering__item--current';
          if ( this_element.hasClass( 'pizza_filtering__item--sauce-tomate' ) ) {
            all_pizzas.appendTo( hidden_pizzas );
            all_filtering_items.removeClass( class_current );  
            this_element.addClass( class_current );          
            $( '.pizza.sauce_tomate' ).appendTo( pizzas_container );
            hidden_pizzas.removeClass( 'sauce_tomate' );
            hidden_pizzas.addClass( 'creme_fraiche' );
            $('[data-pizza-filter="tomate"]').addClass( class_current );
          }
          else if ( this_element.hasClass( 'pizza_filtering__item--creme_fraiche' ) ) {
            all_pizzas.appendTo( hidden_pizzas );
            all_filtering_items.removeClass( class_current );   
            this_element.addClass( class_current );                   
            $( '.pizza.creme_fraiche' ).appendTo( pizzas_container );
            hidden_pizzas.removeClass( 'creme_fraiche' );
            hidden_pizzas.addClass( 'sauce_tomate' );
            $('[data-pizza-filter="fraiche"]').addClass( class_current );
          }
          else {            
            all_filtering_items.removeClass( class_current );   
            this_element.addClass( class_current );      
            if ( hidden_pizzas.hasClass( 'sauce_tomate' ) ) {             
              all_hidden_pizzas.prependTo( pizzas_container );
            }
            else { 
              all_hidden_pizzas.appendTo( pizzas_container );
            }
            hidden_pizzas.removeClass( 'creme_fraiche' );
            hidden_pizzas.removeClass( 'sauce_tomate' );
            $('[data-pizza-filter="tout"]').addClass( class_current );
          }
          window.scrollTo(0, 0);
        });
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page

        /* Triggers Owl Carousel slider on HOME page */
        $( '.home_slider' ).owlCarousel({
          items: 1,
          singleItem: true,
          slideSpeed: 1000,
          autoPlay: true,
          navigation: true,
          navigationText: [
            "<i class='fa fa-angle-left'></i>",
            "<i class='fa fa-angle-right'></i>"
          ]
        });        

        /* Load large slider images on desktop only */
        function slider_images() {
          var image_to_use;
          $( '.home_slide img' ).each(function() {
            var this_element = $(this);
            if ( $(window).width() > 600 ) {        
              image_to_use = this_element.data( 'desktop-img' );
            }
            this_element.attr( 'src', image_to_use );
          });
        }
        slider_images();
        $(window).on('resize', slider_images);         

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'pizza': {
      init: function() {        
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);  

})(jQuery); // Fully reference jQuery after this point.

jQuery(window).load(function() {    
    var $ = jQuery;    
    function sidebar_height_adjustment() {
      if ( $(window).width() >= 1024 ) {
        var sidebar_height = $( '.page_sidebar' ).height();
        var main_column_height = $( '.page_main_column' ).height();
        if ( sidebar_height > main_column_height ) {
          $( '.page_main_column' ).css( 'height', sidebar_height + 'px' );
        }
      }
      else {
        $( '.page_main_column' ).css( 'height', 'auto' );
      }
    }
    sidebar_height_adjustment();
    $( window ).on( 'resize', sidebar_height_adjustment );
    
});

